export const PERMISSION = {
	auth: {
		logout: 'logout',
		email: 'email',
		password: 'password',
	},
	accessAllDivision: 'access-all-division',
	token: {
		list: 'token-list',
		total: 'token-total',
	},
	dashboard: {
		submission: 'dashboard-submission',
		count: 'dashboard-count',
		chartSubmission: 'dashboard-chart-submission',
		chartTraffic: 'dashboard-chart-traffic',
	},
	task: {
		list: 'task-list',
		details: 'task-details',
		downloadValidation: 'task-download-validation',
		approve: 'task-approve',
		reject: 'task-reject',
		revalidate: 'task-revalidate',
		reapprove: 'task-reapprove',
		reapproveUnlock: 'task-reapprove-unlock',
	},
	single: {
		downloadTemplate: 'single-message-download-template',
		upload: 'single-message-upload',
		submit: 'single-message-submit',
		config: 'single-message-config',
		estimateCost: 'single-message-estimate-cost',
		bypasOjk: 'single-message-bypass-ojk',
	},
	personal: {
		downloadTemplate: 'personal-message-download-template',
		upload: 'personal-message-upload',
		submit: 'personal-message-submit',
		config: 'personal-message-config',
		estimateCost: 'personal-message-estimate-cost',
		bypasOjk: 'personal-message-bypass-ojk',
	},
	scheduled: {
		downloadTemplate: 'scheduled-message-download-template',
		upload: 'scheduled-message-upload',
		submit: 'scheduled-message-submit',
		config: 'scheduled-message-config',
		estimateCost: 'scheduled-message-estimate-cost',
		bypasOjk: 'scheduled-message-bypass-ojk',
	},
	report: {
		current: {
			list: 'report-current-list',
			details: 'report-current-details',
			days7: 'report-current-7-days',
		},
		request: {
			list: 'report-request-list',
			add: 'report-request-add',
			download: 'report-request-download'
		}
	},
	setting: {
		blacklist: {
			list: 'settings-blacklist-list',
			add: 'settings-blacklist-add',
			edit: 'settings-blacklist-edit',
			delete: 'settings-blacklist-delete',
		},
		phonebook: {
			list: 'settings-phonebook-list',
			details: 'settings-phonebook-details',
			add: 'settings-phonebook-add',
			edit: 'settings-phonebook-edit',
			delete: 'settings-phonebook-delete',
		},
		phonebookDetail: {
			list: 'settings-phonebook-details-list',
			add: 'settings-phonebook-details-add',
			edit: 'settings-phonebook-details-edit',
			delete: 'settings-phonebook-details-delete',
		},
		masking: {
			list: 'settings-masking-list',
		}
	},
	general: {
		client: 'general-client',
		division: 'general-division',
		sender: 'general-sender',
		provider: 'general-provider',
		servicetype: 'general-servicetype',
		uploadby: 'general-uploadby',
		batchnameTransaction: 'general-batchname-transaction',
		batchnameTask: 'general-batchname-task',
		uploadstatus: 'general-uploadstatus',
		phonebook: 'general-phonebook',
		phonebookDetails: 'general-phonebook-details',
	}
}